export enum DashboardActionTypes {
    API_RESPONSE_SUCCESS = '@@dashboard/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@dashboard/API_RESPONSE_ERROR',

    GET_DASHBOARD_MAIN = '@@dashboard/GET_DASHBOARD_MAIN',
    GET_REPORT_READY = '@@dashboard/GET_REPORT_READY',
    GET_PATIENT_LIST = '@@dashboard/GET_PATIENT_LIST',
    GET_CATEGORY_SALES = '@@dashboard/GET_CATEGORY_SALES',
    GET_CATEGORY_YEARLY_SALES = '@@dashboard/GET_CATEGORY_YEARLY_SALES',
    RESET = '@@dashboard/RESET',
    RESET_SUCCESS = '@@dashboard/RESET_SUCCESS',
    RESET_ERROR = '@@dashboard/RESET_ERROR',
}
